const LEGACY_PARAMS = new Set(["SITUACAO", "CANAL", "REGIAO"]);

/**
 * Remove valores de select que não existem mais em CustomAttributes
 * (dados antigos em texto livre impedem salvar e quebram o MUI Select).
 */
export const sanitizeContactDynamicFields = (
	fields,
	groups = [],
	attributeRows = []
) => {
	if (!fields || typeof fields !== "object") {
		return {};
	}

	const out = { ...fields };

	for (const g of groups) {
		if (!g?.param || LEGACY_PARAMS.has(g.param)) continue;

		const allowed = new Set(
			(attributeRows || [])
				.filter(r => r.param === g.param)
				.map(r => r.value)
		);

		const val = out[g.param];

		if (g.fieldKind === "SELECT_SINGLE") {
			const s = val == null || val === "" ? "" : String(val).trim();
			out[g.param] = s && allowed.has(s) ? s : "";
			continue;
		}

		if (
			g.fieldKind === "SELECT_MULTI" ||
			g.fieldKind === "SELECT_MULTI_LIMITED"
		) {
			let arr = [];
			if (Array.isArray(val)) {
				arr = val.map(v => String(v).trim()).filter(Boolean);
			} else if (val != null && String(val).trim()) {
				arr = String(val)
					.split(",")
					.map(x => x.trim())
					.filter(Boolean);
			}
			arr = arr.filter(v => allowed.has(v));
			const max =
				g.fieldKind === "SELECT_MULTI_LIMITED" ? Number(g.multiMax) || 0 : 0;
			if (max > 0 && arr.length > max) {
				arr = arr.slice(0, max);
			}
			out[g.param] = arr;
		}
	}

	return out;
};
